import Vue from 'vue'
import liveMain from './live-main.vue'
import { Toast, Icon, Radio, RadioGroup, Checkbox, Popup, Rate, NoticeBar, Dialog, Button } from 'vant'
import 'vant/lib/icon/local.css'
import 'vant/lib/index.css'
import '@/scss/reset.css'
import '@/iconfont/iconfont.css'
import { errorSLS } from '@/utils/sls'
// import { DEVlocalStorage } from '@/utils/utils'

// 设置默认用户信息
// DEVlocalStorage({"avatar":"https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJicKuWo9t2xr2j6ghp5esgy9x9CrZAlfePo4TVSibibxsc95yZdax5GSWCZfjg2UHInKMGJn8Zicmsxg/132","hasPass":false,"id":404,"name":"李晓峰","nickname":"不知","openId":"oBHYj6qlmvGcBidFvS9Kj9YkTV7g","telNo":"18735063453","telVerified":false,"token":"0f275bed73c04f2c845316786d0d39b8","unionId":"o2oXE6AP8Oe8_r86ae1UV7LMayBw","tpTicket":"login_867730738829893632","timeStamp":1626924768673})
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Rate)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(NoticeBar)
Vue.use(Dialog)
Vue.use(Button)

window.SEVER_DEFAULT_PATH = process.env.VUE_APP_SEVER_PATH
window.NUWA_SEVER_PATH = process.env.VUE_APP_NUWA_SEVER_PATH
window.SEVER_PATH = process.env.VUE_APP_COURSE_SEVER_PATH
window.WX_APPID = process.env.VUE_APP_WX_APPID
window.ALI_APPID = process.env.VUE_APP_ALI_APPID

Vue.config.productionTip = false

Vue.config.errorHandler = function (err, vm, info) {
    errorSLS({
        action: 'errorHandler',
        data1: JSON.stringify(err, Object.getOwnPropertyNames(err), 2),
        data2: info,
    })
}

new Vue({
    render: (h) => h(liveMain),
}).$mount('#live-m')
